import React from "react";
import { styled } from "@mui/system";
import Medal from "../Profile/Medal";
import { capitalize } from "lodash";

const Wrapper = styled("div")(() => ({
  display: "flex",
  width: "100%",
  // width: "351px",
  alignItems: "flex-start",
  gap: "12px",
  background: "#FFF",
}));

const MedalWrapper = styled("div")(() => ({
  display: "flex",
}));

const TextWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  flex: "1 0 0",
}));

const Text = styled("div")(() => ({
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "22px",
}));

const SubTextWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: " flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));

const SubText = styled("div")(() => ({
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
}));

interface InviteHeaderModalProps {
  name: string;
  customerID: string;
  tier: "bronze" | "silver" | "gold" | "black";
}

/**
 * A header modal component for inviting users, displaying user information and tier.
 * @param {string} props.name - The name of the user.
 * @param {string} props.customerID - The customer ID of the user.
 * @param {"bronze" | "silver" | "gold" | "black"} props.tier - The tier of the user (bronze, silver, gold, or black).
 */
const InviteHeaderModal = (props: InviteHeaderModalProps) => {
  const { name, customerID, tier } = props;
  return (
    <Wrapper>
      <MedalWrapper>
        <Medal tier={tier} size="small" />
      </MedalWrapper>
      <TextWrapper>
        <Text>{name}</Text>
        <SubTextWrapper>
          <SubText>{customerID}</SubText>
          <SubText>{capitalize(tier)}</SubText>
        </SubTextWrapper>
      </TextWrapper>
    </Wrapper>
  );
};
export default InviteHeaderModal;
